import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/tripadvisor-logo.png")